import type { HTMLAttributes, ReactNode } from 'react';
import './FeedbackBanner.css';

export type FeedbackState = 'correct' | 'incorrect' | 'partial' | 'warning';

const STATE: Record<FeedbackState, { rail: string; bg: string; glyph: string }> = {
  correct: { rail: 'var(--correct)', bg: 'var(--correct-bg)', glyph: '✓' },
  incorrect: { rail: 'var(--incorrect)', bg: 'var(--incorrect-bg)', glyph: '✕' },
  partial: { rail: 'var(--partial)', bg: 'var(--partial-bg)', glyph: '≈' },
  warning: { rail: 'var(--warning)', bg: 'var(--warning-bg)', glyph: '!' },
};

export interface FeedbackBannerProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  state?: FeedbackState;
  title?: ReactNode;
  /** Short mono reference line under the detail (e.g. "modeled: array · expected: graph"). */
  slug?: ReactNode;
  children?: ReactNode;
}

export function FeedbackBanner({
  state = 'correct',
  title,
  children,
  slug,
  style,
  ...rest
}: FeedbackBannerProps) {
  const meta = STATE[state];
  return (
    <div
      className="uc-fb"
      style={{ borderLeftColor: meta.rail, background: meta.bg, ...style }}
      role="status"
      {...rest}
    >
      <span className="uc-fb__icon" style={{ background: meta.rail }}>
        {meta.glyph}
      </span>
      <div className="uc-fb__body">
        {title && <div className="uc-fb__title">{title}</div>}
        {children && <div className="uc-fb__detail">{children}</div>}
        {slug && <div className="uc-fb__ref">{slug}</div>}
      </div>
    </div>
  );
}
